import { render, staticRenderFns } from "./56.vue?vue&type=template&id=6c33841d&scoped=true&"
var script = {}
import style0 from "./56.vue?vue&type=style&index=0&id=6c33841d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c33841d",
  null
  
)

export default component.exports